import viddsee from '@/scripts/viddsee';
import { MiniTranslator } from '@/scripts/helpers/mini-translator';
import loginController from '@/scripts/libs/login/controller';
import { makeHandler } from '../../handler-maker';
import { checkParameterRequirements } from './check-parameter-requirements';

const miniI18n = new MiniTranslator({
  en: {
    'need-login': 'To watch the full film, please sign up on Viddsee to continue. No worries, it\'s free!',
  },
  id: {
    'need-login': 'Untuk menonton filmnya sampai selesai, daftar ke Viddsee dan lanjutkan menonton. Jangan khawatir, gratis kok!',
  },
  zh: {
    'need-login': '欲收看完整影片，請註冊Viddsee帳戶。放心，是免費的！',
  },
});

export default makeHandler({
  async condition() {
    if (
      location.pathname.startsWith('/video/') ||
      location.pathname.startsWith('/c/')
    ) {
      return false;
    }

    const isRequiredToTrigger = checkParameterRequirements();

    if (!isRequiredToTrigger) {
      return false;
    }

    const isLoggedIn = !!(await loginController.getUser());
    if (!isLoggedIn) {
      return true;
    }
  },
  trigger() {
    viddsee.ui.modal.register.open({
      loginReason: miniI18n.t('need-login'),
    });
  },
});
